import request from '@/utils/request'

export default {
  getVoucherList (params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/voucher/search/list`,
      method: 'get',
      params
    })
  },
  getVoucherDetail (uuid) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/voucher/${uuid}`,
      method: 'get'
    })
  }
}
